import Swal from 'sweetalert2';
import { fetchToken, fetchTokenFile } from '../helpers/fetch';
import { const_routes } from '../helpers/const_routes';
import { MODULE_INTEGRATION_META } from '../../pages/end-user-search/moduleIntegrationMeta';

/**
 * POST /api/v1/semantic/bridge/view
 */
export const startIntegrationBridgeView = (body) => {
  return async () => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        'bridge/view',
        body,
        'POST'
      );
      const bodyResp = await resp.json();

      if (bodyResp.ok === false && bodyResp.code === 'bak-aut-tok-001') {
        return bodyResp;
      }
      if (bodyResp.ok === false && bodyResp.code === 'bak-aut-tok-002') {
        return bodyResp;
      }
      if (bodyResp.ok === false && bodyResp.code === 'bak-error-001') {
        Swal.fire('Error', bodyResp.msg || 'Error bridge view', 'error');
        return bodyResp;
      }
      return bodyResp;
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudo ejecutar la búsqueda integrada (view)', 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

/**
 * POST /api/v1/semantic/bridge/dashboard
 */
export const startIntegrationBridgeDashboard = (body) => {
  return async () => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        'bridge/dashboard',
        body,
        'POST'
      );
      const bodyResp = await resp.json();

      if (bodyResp.ok === false && bodyResp.code === 'bak-aut-tok-001') {
        return bodyResp;
      }
      if (bodyResp.ok === false && bodyResp.code === 'bak-aut-tok-002') {
        return bodyResp;
      }
      if (bodyResp.ok === false && bodyResp.code === 'bak-error-001') {
        Swal.fire('Error', bodyResp.msg || 'Error bridge dashboard', 'error');
        return bodyResp;
      }
      return bodyResp;
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudo ejecutar la búsqueda integrada (dashboard)', 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

/**
 * GET /api/v1/semantic/bridge/targets/:sourceModule
 */
export const startIntegrationBridgeTargets = (sourceModule) => {
  return async () => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        `bridge/targets/${sourceModule}`
      );
      const bodyResp = await resp.json();
      return bodyResp;
    } catch (error) {
      console.error(error);
      return { ok: false, targets: [], msg: String(error) };
    }
  };
};

/**
 * GET /api/v1/semantic/bridge/filter-schema/:moduleKey
 */
export const startIntegrationBridgeFilterSchema = (moduleKey) => {
  return async () => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        `bridge/filter-schema/${moduleKey}`
      );
      return await resp.json();
    } catch (error) {
      console.error(error);
      return { ok: false, schema: null, msg: String(error) };
    }
  };
};

/**
 * POST /api/v1/semantic/bridge/filter-options
 */
export const startIntegrationBridgeFilterOptions = (body) => {
  return async () => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        'bridge/filter-options',
        body,
        'POST'
      );
      return await resp.json();
    } catch (error) {
      console.error(error);
      return { ok: false, options: { series: [], ciiuLevel2: [], problems: [], byField: {} }, msg: String(error) };
    }
  };
};

/**
 * POST /api/v1/semantic/bridge/filter — intersección sobre ids M3/M4 (sin re-embed).
 */
export const startIntegrationBridgeFilter = (body) => {
  return async () => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        'bridge/filter',
        body,
        'POST'
      );
      const bodyResp = await resp.json();
      if (bodyResp.ok === false && bodyResp.code === 'bak-error-001') {
        Swal.fire('Error', bodyResp.msg || 'Error al filtrar resultados', 'error');
      }
      return bodyResp;
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudo filtrar los resultados integrados', 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

/**
 * GET /api/v1/{module}/get/:id — carga registro completo y lo deja en *Selected.
 */
export const startLoadIntegrationModuleRecord = (moduleKey, id) => {
  return async (dispatch) => {
    const meta = MODULE_INTEGRATION_META[moduleKey];
    if (!meta || !id) {
      return { ok: false, msg: 'moduleKey/id inválidos' };
    }
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${meta.route}`,
        `get/${id}`
      );
      const bodyResp = await resp.json();
      if (!bodyResp.ok) {
        return bodyResp;
      }
      const record =
        bodyResp[meta.responseKey] ||
        bodyResp.visionObject ||
        bodyResp[moduleKey] ||
        null;
      if (!record) {
        return { ok: false, msg: 'Registro no encontrado en respuesta' };
      }
      dispatch(meta.selectAction(record));
      return { ok: true, record };
    } catch (error) {
      console.error(error);
      return { ok: false, msg: String(error) };
    }
  };
};

/**
 * GET /api/v1/semantic/search-field-configs/:moduleKey
 */
export const startLoadSearchFieldConfigs = (moduleKey, includeDeleted = false) => {
  return async () => {
    try {
      const qs = includeDeleted ? '?includeDeleted=true' : '';
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        `search-field-configs/${moduleKey}${qs}`
      );
      const bodyResp = await resp.json();
      if (bodyResp.ok === false && bodyResp.code === 'bak-error-001') {
        Swal.fire('Error', bodyResp.msg || 'Error al cargar filtros de búsqueda', 'error');
      }
      return bodyResp;
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudieron cargar las configuraciones de filtro', 'error');
      return { ok: false, rows: [], msg: String(error) };
    }
  };
};

/**
 * PUT /api/v1/semantic/search-field-configs/:id
 */
export const startUpdateSearchFieldConfig = (id, patch) => {
  return async () => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        `search-field-configs/${id}`,
        patch,
        'PUT'
      );
      const bodyResp = await resp.json();
      if (bodyResp.ok === false && bodyResp.code === 'bak-error-001') {
        Swal.fire('Error', bodyResp.msg || 'Error al guardar el filtro', 'error');
      }
      return bodyResp;
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudo guardar la configuración de filtro', 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

/**
 * GET /api/v1/semantic/panel/filter-schema/:moduleKey
 */
export const startPanelFilterSchema = (moduleKey) => {
  return async () => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        `panel/filter-schema/${moduleKey}`
      );
      return await resp.json();
    } catch (error) {
      console.error(error);
      return { ok: false, schema: null, msg: String(error) };
    }
  };
};

/**
 * GET /api/v1/semantic/search-field-configs-excel
 */
export const startDownloadSearchFieldConfigsExcel = (includeDeleted = true) => {
  return async () => {
    try {
      const qs = includeDeleted ? '?includeDeleted=true' : '?includeDeleted=false';
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        `search-field-configs-excel${qs}`
      );
      if (!resp.ok) {
        const bodyResp = await resp.json().catch(() => ({}));
        if (bodyResp.code === 'bak-error-001') {
          Swal.fire('Error', bodyResp.msg || 'Error al exportar filtros', 'error');
        }
        return { ok: false, msg: bodyResp.msg || 'download-error' };
      }
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'semantic_bridge_filter_configs.xlsx';
      link.click();
      window.URL.revokeObjectURL(url);
      return { ok: true };
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudo descargar el Excel de filtros', 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

/**
 * POST /api/v1/semantic/search-field-configs-excel
 */
export const startImportSearchFieldConfigsExcel = (file, apply) => {
  return async () => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('apply', apply ? 'true' : 'false');
      const resp = await fetchTokenFile(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEMANTIC}`,
        'search-field-configs-excel',
        formData,
        'POST'
      );
      const bodyResp = await resp.json();
      if (bodyResp.ok === false && bodyResp.code === 'bak-error-001') {
        Swal.fire('Error', bodyResp.msg || 'Error al importar filtros', 'error');
      }
      return bodyResp;
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudo importar el Excel de filtros', 'error');
      return { ok: false, msg: String(error) };
    }
  };
};
